import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useReveal } from '../../../hooks/useReveal';

const pillars = [
  {
    icon: 'ri-shield-check-line',
    titleKey: 'about.pillar1.title',
    descKey: 'about.pillar1.desc',
  },
  {
    icon: 'ri-store-2-line',
    titleKey: 'about.pillar2.title',
    descKey: 'about.pillar2.desc',
  },
  {
    icon: 'ri-global-line',
    titleKey: 'about.pillar3.title',
    descKey: 'about.pillar3.desc',
  },
];

export default function AboutPreview() {
  const ref = useReveal();
  const { t } = useTranslation();

  return (
    <section ref={ref} className="bg-white py-16 lg:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Left: Image column */}
          <div className="reveal-left relative">
            {/* Main image */}
            <div className="relative rounded-2xl overflow-hidden h-[520px] lg:h-[620px]">
              <img
                src="https://static.readdy.ai/image/3946f031037e28555363a2e50b79cfcb/826f123b1818fc124e0c8a90aea4eab7.png"
                alt="MONARU Partnership Seoul"
                className="w-full h-full object-cover object-top"
              />
              {/* Dark overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
            </div>
          </div>

          {/* Right: Text column */}
          <div className="reveal-right">
            {/* Eyebrow */}
            <p className="text-xs font-sans font-semibold tracking-[0.2em] text-navy/40 uppercase mb-5">
              {t('about.eyebrow')}
            </p>

            {/* Headline */}
            <h2 className="font-serif text-navy leading-tight mb-6">
              <span className="block text-3xl lg:text-5xl font-bold">
                {t('about.heading1')}
              </span>
            </h2>

            {/* Description */}
            <p className="text-navy/60 text-base font-sans leading-relaxed mb-10 max-w-lg">
              {t('about.desc1')}
            </p>

            {/* Value Pillars */}
            <div className="space-y-5 mb-10">
              {pillars.map((p) => (
                <div key={p.titleKey} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-lg bg-[#F5F6F8]">
                    <i className={`${p.icon} text-navy text-lg`} />
                  </div>
                  <div>
                    <p className="text-sm font-sans font-semibold text-navy mb-0.5">
                      {t(p.titleKey)}
                    </p>
                    <p className="text-sm text-navy/50 font-sans leading-relaxed">
                      {t(p.descKey)}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-sm font-sans font-semibold text-navy tracking-wide border-b border-navy pb-0.5 hover:gap-3 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              {t('about.learnStory')}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
